"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mobile = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/core/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var Mobile = function Mobile(_ref) {
  var crumbs = _ref.crumbs,
    onCrumbClick = _ref.onCrumbClick;
  var crumb = crumbs[crumbs.length - 2];
  var rootClassName = (0, _classnames["default"])('cds-Link', 'cds-Link--IconLeft', 'cds-ButtonLink', 'cds-Breadcrumbs-Link--Mobile');
  if (!crumb) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("a", {
    className: rootClassName,
    href: crumb.url,
    onClick: onCrumbClick === null || onCrumbClick === void 0 ? void 0 : onCrumbClick(crumb.url)
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.arrowLeft,
    size: _Icon.ICON_SIZE.small
  }), crumb.title);
};
exports.Mobile = Mobile;